module.exports = __webpack_public_path__ + "img/UrlFill.1914b3e7.png";